import React, { useState, useEffect } from 'react';
import '../styles/Charges.css';

function Charges() {
  // État pour le mois sélectionné (format YYYY-MM)
  const [moisSelectionne, setMoisSelectionne] = useState(() => {
    const maintenant = new Date();
    return `${maintenant.getFullYear()}-${String(maintenant.getMonth() + 1).padStart(2, '0')}`;
  });

  // Données de test avec charges sur plusieurs mois
  const [charges, setCharges] = useState(() => {
    // Charger depuis localStorage ou utiliser les données par défaut
    const savedCharges = localStorage.getItem('charges');
    if (savedCharges) {
      return JSON.parse(savedCharges);
    }
    
    return [
      // Juin 2025
      { 
        id: 1, 
        description: 'Électricité', 
        montant: 350.00, 
        categorie: 'SERVICES', 
        recurrence: 'mensuelle',
        mois: '2025-06',
        dateEcheance: '2025-06-15', 
        statut: 'PAYÉE',
        datePaiement: '2025-06-14',
        methodePaiement: 'Virement bancaire',
        devise: 'MAD'
      },
      { 
        id: 2, 
        description: 'Nettoyage bureau', 
        montant: 200.00, 
        categorie: 'SERVICES', 
        recurrence: 'mensuelle',
        mois: '2025-06',
        dateEcheance: '2025-06-01', 
        statut: 'PAYÉE',
        datePaiement: '2025-06-01',
        methodePaiement: 'Carte de crédit',
        devise: 'MAD'
      },
      { 
        id: 3, 
        description: 'Eau', 
        montant: 85.00, 
        categorie: 'SERVICES', 
        recurrence: 'mensuelle',
        mois: '2025-06',
        dateEcheance: '2025-06-10', 
        statut: 'PAYÉE',
        datePaiement: '2025-06-09',
        methodePaiement: 'Prélèvement automatique',
        devise: 'MAD'
      },
      { 
        id: 4, 
        description: 'Assurance responsabilité', 
        montant: 120.00, 
        categorie: 'ASSURANCE', 
        recurrence: 'unique',
        mois: '2025-06',
        dateEcheance: '2025-06-30', 
        statut: 'PAYÉE',
        datePaiement: '2025-06-28',
        methodePaiement: 'Virement bancaire',
        devise: 'MAD'
      },
      // Juillet 2025
      { 
        id: 5, 
        description: 'Électricité', 
        montant: 350.00, 
        categorie: 'SERVICES', 
        recurrence: 'mensuelle',
        mois: '2025-07',
        dateEcheance: '2025-07-15', 
        statut: 'EN_ATTENTE',
        datePaiement: null,
        methodePaiement: null
      },
      { 
        id: 6, 
        description: 'Nettoyage bureau', 
        montant: 200.00, 
        categorie: 'SERVICES', 
        recurrence: 'mensuelle',
        mois: '2025-07',
        dateEcheance: '2025-07-01', 
        statut: 'PAYÉE',
        datePaiement: '2025-07-01',
        methodePaiement: 'Carte de crédit'
      },
      { 
        id: 7, 
        description: 'Eau', 
        montant: 85.00, 
        categorie: 'SERVICES', 
        recurrence: 'mensuelle',
        mois: '2025-07',
        dateEcheance: '2025-07-10', 
        statut: 'EN_RETARD',
        datePaiement: null,
        methodePaiement: null
      },
      { 
        id: 8, 
        description: 'Loyer bureau', 
        montant: 1500.00, 
        categorie: 'LOYER', 
        recurrence: 'mensuelle',
        mois: '2025-07',
        dateEcheance: '2025-07-01', 
        statut: 'PAYÉE',
        datePaiement: '2025-06-30',
        methodePaiement: 'Virement bancaire'
      }
    ];
  });

  // Sauvegarder dans localStorage quand les charges changent
  useEffect(() => {
    console.log('Sauvegarde des charges dans localStorage:', charges); // Debug
    try {
      localStorage.setItem('charges', JSON.stringify(charges));
      console.log('Charges sauvegardées avec succès'); // Debug
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      setMessage({ type: 'error', text: 'Erreur lors de la sauvegarde des données.' });
    }
  }, [charges]);
  
  const [filtres, setFiltres] = useState({
    categorie: '',
    statut: ''
  });
  
  const [nouvelleCharge, setNouvelleCharge] = useState({
    description: '',
    montant: '',
    categorie: '',
    recurrence: 'mensuelle',
    mois: moisSelectionne,
    dateEcheance: '',
    notes: '',
    devise: 'MAD'
  });
  
  // État pour la devise par défaut
  const [deviseParDefaut, setDeviseParDefaut] = useState('MAD');
  
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [chargeDetails, setChargeDetails] = useState(null);
  const [chargeEnEdition, setChargeEnEdition] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });
  
  // Options pour les filtres et le formulaire
  const categorieOptions = ['SERVICES', 'LOYER', 'MAINTENANCE', 'ASSURANCE', 'AUTRES'];
  const statutOptions = ['EN_ATTENTE', 'PAYÉE', 'EN_RETARD'];
  const recurrenceOptions = ['unique', 'mensuelle'];
  const methodePaiementOptions = ['Carte de crédit', 'Virement bancaire', 'Chèque', 'Espèces', 'Prélèvement automatique'];
  const deviseOptions = ['MAD', 'CAD'];

  // Filtrer les charges du mois sélectionné
  const chargesDuMois = charges.filter(charge => charge.mois === moisSelectionne);
  
  // Appliquer les filtres supplémentaires
  const chargesFiltrees = chargesDuMois.filter(charge => {
    return (
      (filtres.categorie === '' || charge.categorie === filtres.categorie) &&
      (filtres.statut === '' || charge.statut === filtres.statut)
    );
  });

  // Fonctions pour la navigation des mois
  const moisPrecedent = () => {
    const [annee, mois] = moisSelectionne.split('-').map(Number);
    const nouvelleDateMois = new Date(annee, mois - 2); // mois - 2 car getMonth() est 0-indexé
    const nouveauMois = `${nouvelleDateMois.getFullYear()}-${String(nouvelleDateMois.getMonth() + 1).padStart(2, '0')}`;
    setMoisSelectionne(nouveauMois);
  };

  const moisSuivant = () => {
    const [annee, mois] = moisSelectionne.split('-').map(Number);
    const nouvelleDateMois = new Date(annee, mois); // mois car on veut le mois suivant
    const nouveauMois = `${nouvelleDateMois.getFullYear()}-${String(nouvelleDateMois.getMonth() + 1).padStart(2, '0')}`;
    setMoisSelectionne(nouveauMois);
  };

  // Dupliquer les charges du mois précédent
  const dupliquerMoisPrecedent = () => {
    const [annee, mois] = moisSelectionne.split('-').map(Number);
    const moisPrecedentDate = new Date(annee, mois - 2);
    const moisPrecedentStr = `${moisPrecedentDate.getFullYear()}-${String(moisPrecedentDate.getMonth() + 1).padStart(2, '0')}`;
    
    // Trouver les charges récurrentes du mois précédent
    const chargesRecurrentes = charges.filter(charge => 
      charge.mois === moisPrecedentStr && charge.recurrence === 'mensuelle'
    );
    
    if (chargesRecurrentes.length === 0) {
      setMessage({ type: 'warning', text: 'Aucune charge récurrente trouvée pour le mois précédent.' });
      return;
    }
    
    // Vérifier s'il y a déjà des charges pour ce mois
    const chargesExistantes = charges.filter(charge => charge.mois === moisSelectionne);
    if (chargesExistantes.length > 0) {
      if (!window.confirm('Des charges existent déjà pour ce mois. Voulez-vous continuer ?')) {
        return;
      }
    }
    
    // Créer les nouvelles charges
    const nouvellesCharges = chargesRecurrentes.map(charge => ({
      ...charge,
      id: Math.max(...charges.map(c => c.id)) + charges.indexOf(charge) + 1,
      mois: moisSelectionne,
      statut: 'EN_ATTENTE',
      datePaiement: null,
      methodePaiement: null,
      dateEcheance: charge.dateEcheance.replace(moisPrecedentStr, moisSelectionne)
    }));
    
    setCharges([...charges, ...nouvellesCharges]);
    setMessage({ type: 'success', text: `${nouvellesCharges.length} charges récurrentes dupliquées avec succès.` });
  };

  // Fonction pour formater le nom du mois
  const formatMoisAnnee = (moisStr) => {
    const [annee, mois] = moisStr.split('-');
    const moisNoms = [
      'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];
    return `${moisNoms[parseInt(mois) - 1]} ${annee}`;
  };
  
  // Gérer les changements de filtres
  const handleFiltreChange = (e) => {
    const { name, value } = e.target;
    setFiltres({
      ...filtres,
      [name]: value
    });
  };
  
  // Réinitialiser les filtres
  const resetFiltres = () => {
    setFiltres({
      categorie: '',
      statut: ''
    });
  };
  
  // Gérer les changements dans le formulaire de nouvelle charge
  const handleNouvelleChargeChange = (e) => {
    const { name, value } = e.target;
    setNouvelleCharge({
      ...nouvelleCharge,
      [name]: value
    });
  };

  // Mettre à jour le mois de la nouvelle charge quand le mois sélectionné change
  useEffect(() => {
    setNouvelleCharge(prev => ({
      ...prev,
      mois: moisSelectionne
    }));
  }, [moisSelectionne]);
  
  // Ajouter une nouvelle charge
  const ajouterCharge = (e) => {
    e.preventDefault();
    
    // Validation des champs obligatoires
    if (!nouvelleCharge.description || !nouvelleCharge.montant || !nouvelleCharge.categorie) {
      setMessage({ type: 'error', text: 'Veuillez remplir tous les champs obligatoires.' });
      return;
    }

    // Validation du montant
    const montantValide = parseFloat(nouvelleCharge.montant);
    if (isNaN(montantValide) || montantValide <= 0) {
      setMessage({ type: 'error', text: 'Le montant doit être un nombre positif valide.' });
      return;
    }
    
    console.log('Ajout de charge:', nouvelleCharge); // Debug
    
    const newCharge = {
      id: Math.max(...charges.map(c => c.id), 0) + 1,
      description: nouvelleCharge.description,
      montant: montantValide,
      categorie: nouvelleCharge.categorie,
      recurrence: nouvelleCharge.recurrence,
      mois: nouvelleCharge.mois,
      dateEcheance: nouvelleCharge.dateEcheance || null,
      notes: nouvelleCharge.notes || '',
      devise: nouvelleCharge.devise || deviseParDefaut,
      statut: 'EN_ATTENTE',
      datePaiement: null,
      methodePaiement: null
    };
    
    console.log('Nouvelle charge créée:', newCharge); // Debug
    
    // Mise à jour des charges
    const nouvellesCharges = [...charges, newCharge];
    setCharges(nouvellesCharges);
    console.log('Charges après ajout:', nouvellesCharges); // Debug
    
    // Réinitialiser le formulaire
    setNouvelleCharge({
      description: '',
      montant: '',
      categorie: '',
      recurrence: 'mensuelle',
      mois: moisSelectionne,
      dateEcheance: '',
      notes: '',
      devise: deviseParDefaut
    });
    
    setShowModal(false);
    setMessage({ type: 'success', text: 'Charge ajoutée avec succès !' });
  };
  
  // Voir les détails d'une charge
  const voirDetails = (charge) => {
    console.log('voirDetails appelé avec:', charge);
    setChargeDetails(charge);
    setShowDetailsModal(true);
  };

  // Éditer une charge
  const editerCharge = (charge) => {
    console.log('editerCharge appelé avec:', charge);
    setChargeEnEdition({
      id: charge.id,
      description: charge.description,
      montant: charge.montant.toString(),
      categorie: charge.categorie,
      recurrence: charge.recurrence,
      mois: charge.mois,
      dateEcheance: charge.dateEcheance || '',
      notes: charge.notes || '',
      devise: charge.devise || deviseParDefaut
    });
    setShowEditModal(true);
    console.log('Modal d\'édition ouvert');
  };

  // Sauvegarder les modifications d'une charge
  const sauvegarderModifications = (e) => {
    e.preventDefault();
    
    // Validation des champs obligatoires
    if (!chargeEnEdition.description || !chargeEnEdition.montant || !chargeEnEdition.categorie) {
      setMessage({ type: 'error', text: 'Veuillez remplir tous les champs obligatoires.' });
      return;
    }

    // Validation du montant
    const montantValide = parseFloat(chargeEnEdition.montant);
    if (isNaN(montantValide) || montantValide <= 0) {
      setMessage({ type: 'error', text: 'Le montant doit être un nombre positif valide.' });
      return;
    }

    // Mettre à jour la charge
    const chargesModifiees = charges.map(charge => {
      if (charge.id === chargeEnEdition.id) {
        return {
          ...charge,
          description: chargeEnEdition.description,
          montant: montantValide,
          categorie: chargeEnEdition.categorie,
          recurrence: chargeEnEdition.recurrence,
          mois: chargeEnEdition.mois,
          dateEcheance: chargeEnEdition.dateEcheance || null,
          notes: chargeEnEdition.notes || '',
          devise: chargeEnEdition.devise || deviseParDefaut
        };
      }
      return charge;
    });

    setCharges(chargesModifiees);
    setShowEditModal(false);
    setChargeEnEdition(null);
    setMessage({ type: 'success', text: 'Charge modifiée avec succès !' });
  };

  // Gérer les changements dans le formulaire d'édition
  const handleEditionChange = (e) => {
    const { name, value } = e.target;
    setChargeEnEdition({
      ...chargeEnEdition,
      [name]: value
    });
  };
  
  // Supprimer une charge
  const supprimerCharge = (id) => {
    console.log('supprimerCharge appelé avec ID:', id);
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette charge ?')) {
      console.log('Suppression confirmée pour ID:', id);
      setCharges(charges.filter(charge => charge.id !== id));
      setMessage({ type: 'success', text: 'Charge supprimée avec succès !' });
      if (chargeDetails && chargeDetails.id === id) {
        setShowDetailsModal(false);
      }
      console.log('Charge supprimée avec succès');
    }
  };
  
  // Changer le statut d'une charge
  const changerStatut = (id, nouveauStatut, methodePaiement = null) => {
    const updatedCharges = charges.map(charge => {
      if (charge.id === id) {
        return { 
          ...charge, 
          statut: nouveauStatut,
          datePaiement: nouveauStatut === 'PAYÉE' ? new Date().toISOString().split('T')[0] : charge.datePaiement,
          methodePaiement: nouveauStatut === 'PAYÉE' ? methodePaiement : charge.methodePaiement
        };
      }
      return charge;
    });
    setCharges(updatedCharges);
    
    if (chargeDetails && chargeDetails.id === id) {
      setChargeDetails({
        ...chargeDetails,
        statut: nouveauStatut,
        datePaiement: nouveauStatut === 'PAYÉE' ? new Date().toISOString().split('T')[0] : chargeDetails.datePaiement,
        methodePaiement: nouveauStatut === 'PAYÉE' ? methodePaiement : chargeDetails.methodePaiement
      });
    }

    const statusLabels = {
      'PAYÉE': 'payée',
      'EN_ATTENTE': 'en attente',
      'EN_RETARD': 'en retard'
    };
    setMessage({ type: 'success', text: `Charge marquée comme ${statusLabels[nouveauStatut]} !` });
  };

  // Vérifier si une charge est en retard
  const estEnRetard = (charge) => {
    if (charge.statut === 'PAYÉE') return false;
    const dateEcheance = new Date(charge.dateEcheance);
    const maintenant = new Date();
    return maintenant > dateEcheance;
  };
  
  // Formater le montant en devise
  const formaterMontant = (montant, devise = deviseParDefaut) => {
    if (devise === 'MAD') {
      return new Intl.NumberFormat('fr-MA', { 
        style: 'currency', 
        currency: 'MAD',
        minimumFractionDigits: 2
      }).format(montant);
    } else {
      return new Intl.NumberFormat('fr-CA', { 
        style: 'currency', 
        currency: 'CAD' 
      }).format(montant);
    }
  };
  
  // Fonction pour obtenir la classe CSS du badge de statut
  const getStatutBadgeClass = (statut) => {
    switch(statut) {
      case 'EN_ATTENTE': return 'en-attente';
      case 'PAYÉE': return 'payee';
      case 'EN_RETARD': return 'en-retard';
      default: return 'en-attente';
    }
  };

  // Fonction pour obtenir le texte affiché du statut
  const getStatutText = (statut) => {
    switch(statut) {
      case 'EN_ATTENTE': return '🕐 En attente';
      case 'PAYÉE': return '✅ Payée';
      case 'EN_RETARD': return '⚠️ En retard';
      default: return '🕐 En attente';
    }
  };

  // Calculer les statistiques pour le mois sélectionné
  const calculerStatistiques = () => {
    const totalCharges = chargesDuMois.length;
    const totalMontant = chargesDuMois.reduce((sum, charge) => sum + parseFloat(charge.montant), 0);
    
    const chargesPayees = chargesDuMois.filter(charge => charge.statut === 'PAYÉE');
    const chargesEnAttente = chargesDuMois.filter(charge => charge.statut === 'EN_ATTENTE');
    const chargesEnRetard = chargesDuMois.filter(charge => charge.statut === 'EN_RETARD' || estEnRetard(charge));
    
    const montantPaye = chargesPayees.reduce((sum, charge) => sum + parseFloat(charge.montant), 0);
    
    return {
      totalMontant: formaterMontant(totalMontant),
      totalPayees: chargesPayees.length,
      totalEnAttente: chargesEnAttente.length,
      totalEnRetard: chargesEnRetard.length,
      montantPaye: formaterMontant(montantPaye)
    };
  };
  
  // Calculer les charges par catégorie pour le mois sélectionné
  const calculerChargesParCategorie = () => {
    const chargesParCategorie = {};
    
    chargesDuMois.forEach(charge => {
      if (!chargesParCategorie[charge.categorie]) {
        chargesParCategorie[charge.categorie] = 0;
      }
      chargesParCategorie[charge.categorie] += parseFloat(charge.montant);
    });
    
    return Object.entries(chargesParCategorie).map(([categorie, montant]) => ({
      categorie,
      montant,
      montantFormate: formaterMontant(montant)
    }));
  };

  // Fonction pour formater le statut en français
  const formatStatut = (statut) => {
    const statusLabels = {
      'EN_ATTENTE': 'En attente',
      'PAYÉE': 'Payée',
      'EN_RETARD': 'En retard'
    };
    return statusLabels[statut] || statut;
  };

  // Fonction pour formater la récurrence
  const formatRecurrence = (recurrence) => {
    return recurrence === 'mensuelle' ? 'Mensuel' : 'Unique';
  };

  // Effacer le message après 5 secondes
  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ type: '', text: '' });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);
  
  const stats = calculerStatistiques();
  const chargesParCategorie = calculerChargesParCategorie();
  
  return (
    <div className="charges-container">
      {/* Message de feedback */}
      {message.text && (
        <div className={`message ${message.type}`} style={{ 
          marginBottom: '20px', 
          padding: '10px', 
          borderRadius: '5px',
          backgroundColor: message.type === 'success' ? '#d4edda' : 
                           message.type === 'warning' ? '#fff3cd' : 
                           message.type === 'error' ? '#f8d7da' : '#f8d7da',
          color: message.type === 'success' ? '#155724' : 
                 message.type === 'warning' ? '#856404' : 
                 message.type === 'error' ? '#721c24' : '#721c24',
          border: `1px solid ${message.type === 'success' ? '#c3e6cb' : 
                                message.type === 'warning' ? '#ffeaa7' : 
                                message.type === 'error' ? '#f5c6cb' : '#f5c6cb'}`
        }}>
          {message.text}
        </div>
      )}

      {/* Sélecteur de mois et devise */}
      <div className="charges-header">
        <div className="month-selector">
          <button className="btn-secondary month-nav-button" onClick={moisPrecedent}>
            <i className="fas fa-chevron-left"></i> Précédent
          </button>
          
          <h2 className="month-title">{formatMoisAnnee(moisSelectionne)}</h2>
          
          <button className="btn-secondary month-nav-button" onClick={moisSuivant}>
            Suivant <i className="fas fa-chevron-right"></i>
          </button>

        </div>

        <div className="charges-header-actions">
          <button className="btn-secondary duplicate-month-button" onClick={dupliquerMoisPrecedent}>
            <i className="fas fa-copy"></i> Dupliquer mois précédent
          </button>

          <div className="currency-selector">
            <label htmlFor="devise-defaut">Devise</label>
            <select
              id="devise-defaut"
              value={deviseParDefaut}
              onChange={(e) => setDeviseParDefaut(e.target.value)}
              className="select-devise"
            >
              <option value="MAD">MAD - Dirham marocain</option>
              <option value="CAD">CAD - Dollar canadien</option>
            </select>
          </div>

          <button className="btn-primary new-charge-button" onClick={() => setShowModal(true)}>
            <span>+</span> Nouvelle charge
          </button>
        </div>
      </div>
      
      {/* Statistiques - 6 cartes en ligne */}
      <div className="stats-container">
        <div className="stat-card">
          <h3>Total charges</h3>
          <p className="stat-value">{stats.totalMontant}</p>
        </div>
        <div className="stat-card">
          <h3>Charges payées</h3>
          <p className="stat-value" style={{ color: '#28a745' }}>{stats.totalPayees}</p>
        </div>
        <div className="stat-card">
          <h3>En attente</h3>
          <p className="stat-value" style={{ color: '#ffc107' }}>{stats.totalEnAttente}</p>
        </div>
        <div className="stat-card">
          <h3>En retard</h3>
          <p className="stat-value" style={{ color: '#dc3545' }}>{stats.totalEnRetard}</p>
        </div>
        <div className="stat-card">
          <h3>Montant total</h3>
          <p className="stat-value" style={{ color: '#007bff' }}>{stats.totalMontant}</p>
        </div>
        <div className="stat-card">
          <h3>Montant payé</h3>
          <p className="stat-value" style={{ color: '#28a745' }}>{stats.montantPaye}</p>
        </div>
      </div>
      
      <div className="repartition-container">
        <h3>Répartition des charges par catégorie</h3>
        <div className="categories-grid">
          {chargesParCategorie.map((item, index) => (
            <div key={index} className="categorie-card">
              <div className="categorie-icon">
                {item.categorie === 'LOYER' && '🏢'}
                {item.categorie === 'SERVICES' && '⚡'}
                {item.categorie === 'ASSURANCE' && '🛡️'}
                {item.categorie === 'MAINTENANCE' && '�'}
                {item.categorie === 'AUTRES' && '📋'}
              </div>
              <div className="categorie-info">
                <h4>{item.categorie}</h4>
                <p>{item.montantFormate}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="filtres-container">
        <div className="filtre-group">
          <label>Catégorie:</label>
          <select 
            name="categorie" 
            value={filtres.categorie} 
            onChange={handleFiltreChange}
          >
            <option value="">Toutes</option>
            {categorieOptions.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>
        
        <div className="filtre-group">
          <label>Statut:</label>
          <select 
            name="statut" 
            value={filtres.statut} 
            onChange={handleFiltreChange}
          >
            <option value="">Tous</option>
            {statutOptions.map(option => (
              <option key={option} value={option}>{formatStatut(option)}</option>
            ))}
          </select>
        </div>
        
        <button className="btn-secondary" onClick={resetFiltres}>
          Réinitialiser
        </button>
      </div>
      
      <div className="charges-table-container">
        <table className="charges-table">
          <thead>
            <tr>
              <th>DESCRIPTION</th>
              <th>MOIS</th>
              <th>MONTANT</th>
              <th>CATÉGORIE</th>
              <th>ÉCHÉANCE</th>
              <th>STATUT</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {chargesFiltrees.map(charge => (
              <tr key={charge.id}>
                <td>{charge.description}</td>
                <td>{formatMoisAnnee(charge.mois)}</td>
                <td>
                  <div>
                    {formaterMontant(charge.montant, charge.devise || deviseParDefaut)}
                    <br />
                    <small style={{ color: '#666' }}>
                      {formatRecurrence(charge.recurrence)}
                    </small>
                  </div>
                </td>
                <td>{charge.categorie}</td>
                <td>{charge.dateEcheance}</td>
                <td>
                  <div className="status-dropdown">
                    <div 
                      className={`status-badge ${getStatutBadgeClass(charge.statut)}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {getStatutText(charge.statut)}
                    </div>
                    <div className="status-dropdown-content">
                      <div 
                        className="status-dropdown-item en-attente"
                        onClick={(e) => {
                          e.stopPropagation();
                          changerStatut(charge.id, 'EN_ATTENTE');
                        }}
                      >
                        🕐 En attente
                      </div>
                      <div 
                        className="status-dropdown-item payee"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (charge.statut !== 'PAYÉE') {
                            const methode = prompt('Méthode de paiement:\n1. Carte de crédit\n2. Virement bancaire\n3. Chèque\n4. Espèces\n5. Prélèvement automatique\n\nEntrez le numéro (1-5):');
                            const methodes = ['', 'Carte de crédit', 'Virement bancaire', 'Chèque', 'Espèces', 'Prélèvement automatique'];
                            const methodePaiement = methodes[parseInt(methode)] || 'Virement bancaire';
                            changerStatut(charge.id, 'PAYÉE', methodePaiement);
                          } else {
                            changerStatut(charge.id, 'PAYÉE');
                          }
                        }}
                      >
                        ✅ Payée
                      </div>
                      <div 
                        className="status-dropdown-item en-retard"
                        onClick={(e) => {
                          e.stopPropagation();
                          changerStatut(charge.id, 'EN_RETARD');
                        }}
                      >
                        ⚠️ En retard
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="actions-buttons">
                    <button 
                      className="btn-action btn-details" 
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log('Clic sur détails pour charge:', charge.id);
                        voirDetails(charge);
                      }}
                      title="Voir détails"
                    >
                      👁️
                    </button>
                    <button 
                      className="btn-action btn-edit" 
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log('Clic sur éditer pour charge:', charge.id);
                        editerCharge(charge);
                      }}
                      title="Modifier"
                    >
                      ✏️
                    </button>
                    <button 
                      className="btn-action btn-delete" 
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log('Clic sur supprimer pour charge:', charge.id);
                        supprimerCharge(charge.id);
                      }}
                      title="Supprimer"
                    >
                      🗑️
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {chargesFiltrees.length === 0 && (
          <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
            Aucune charge trouvée pour {formatMoisAnnee(moisSelectionne)}
          </div>
        )}
      </div>
      
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Ajouter une nouvelle charge</h3>
              <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
            </div>
            <form onSubmit={ajouterCharge}>
              <div className="form-row">
                <div className="form-group">
                  <label>Description:</label>
                  <input 
                    type="text" 
                    name="description" 
                    value={nouvelleCharge.description} 
                    onChange={handleNouvelleChargeChange} 
                    required 
                    placeholder="Ex: Électricité"
                  />
                </div>
                <div className="form-group">
                  <label>Mois concerné:</label>
                  <input 
                    type="month" 
                    name="mois" 
                    value={nouvelleCharge.mois} 
                    onChange={handleNouvelleChargeChange}
                    required 
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Montant ({deviseParDefaut}):</label>
                  <input 
                    type="number" 
                    name="montant" 
                    value={nouvelleCharge.montant} 
                    onChange={handleNouvelleChargeChange} 
                    step="0.01"
                    min="0"
                    required 
                    placeholder="0.00"
                  />
                </div>
                <div className="form-group">
                  <label>Devise:</label>
                  <select 
                    name="devise" 
                    value={nouvelleCharge.devise} 
                    onChange={handleNouvelleChargeChange}
                    required
                  >
                    {deviseOptions.map(option => (
                      <option key={option} value={option}>
                        {option === 'MAD' ? 'MAD - Dirham marocain' : 'CAD - Dollar canadien'}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Catégorie:</label>
                  <select 
                    name="categorie" 
                    value={nouvelleCharge.categorie} 
                    onChange={handleNouvelleChargeChange}
                    required
                  >
                    <option value="">Sélectionner</option>
                    {categorieOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Récurrence:</label>
                  <select 
                    name="recurrence" 
                    value={nouvelleCharge.recurrence} 
                    onChange={handleNouvelleChargeChange}
                    required
                  >
                    {recurrenceOptions.map(option => (
                      <option key={option} value={option}>
                        {formatRecurrence(option)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Échéance (optionnelle):</label>
                  <input 
                    type="date" 
                    name="dateEcheance" 
                    value={nouvelleCharge.dateEcheance} 
                    onChange={handleNouvelleChargeChange} 
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group full-width">
                  <label>Notes (optionnel):</label>
                  <input 
                    type="text" 
                    name="notes" 
                    value={nouvelleCharge.notes} 
                    onChange={handleNouvelleChargeChange} 
                    placeholder="Notes ou commentaires..."
                  />
                </div>
              </div>
              
              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>
                  Annuler
                </button>
                <button type="submit" className="btn-primary">
                  Ajouter
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      
      {showDetailsModal && chargeDetails && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Détails de la charge</h3>
              <button className="close-btn" onClick={() => setShowDetailsModal(false)}>×</button>
            </div>
            <div className="charge-details">
              <div className="charge-info">
                <h4>Informations générales</h4>
                <p><strong>Description:</strong> {chargeDetails.description}</p>
                <p><strong>Mois:</strong> {formatMoisAnnee(chargeDetails.mois)}</p>
                <p><strong>Montant:</strong> {formaterMontant(chargeDetails.montant)}</p>
                <p><strong>Catégorie:</strong> {chargeDetails.categorie}</p>
                <p><strong>Récurrence:</strong> {formatRecurrence(chargeDetails.recurrence)}</p>
                {chargeDetails.dateEcheance && (
                  <p><strong>Date d'échéance:</strong> {chargeDetails.dateEcheance}</p>
                )}
                <p><strong>Statut:</strong> 
                  <span className={`statut-badge statut-${chargeDetails.statut.toLowerCase().replace(/_/g, '-')}`}>
                    {formatStatut(chargeDetails.statut)}
                  </span>
                </p>
                {chargeDetails.datePaiement && (
                  <p><strong>Date de paiement:</strong> {chargeDetails.datePaiement}</p>
                )}
                {chargeDetails.methodePaiement && (
                  <p><strong>Méthode de paiement:</strong> {chargeDetails.methodePaiement}</p>
                )}
                {chargeDetails.notes && (
                  <p><strong>Notes:</strong> {chargeDetails.notes}</p>
                )}
              </div>
              
              {chargeDetails.statut !== 'PAYÉE' && (
                <div className="charge-actions">
                  <h4>Actions</h4>
                  <div className="paiement-form">
                    <h5>Marquer comme payée</h5>
                    <div className="form-group">
                      <label>Méthode de paiement:</label>
                      <select 
                        id="methodePaiement" 
                        defaultValue=""
                        onChange={(e) => {
                          if (e.target.value) {
                            changerStatut(chargeDetails.id, 'PAYÉE', e.target.value);
                          }
                        }}
                      >
                        <option value="">Sélectionner</option>
                        {methodePaiementOptions.map(option => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </select>
                    </div>
                    
                    <div className="other-actions">
                      {chargeDetails.statut !== 'EN_RETARD' && (
                        <button 
                          className="btn-secondary" 
                          onClick={() => changerStatut(chargeDetails.id, 'EN_RETARD')}
                        >
                          Marquer en retard
                        </button>
                      )}
                      <button 
                        className="btn-secondary" 
                        onClick={() => supprimerCharge(chargeDetails.id)}
                        style={{ marginLeft: '10px', backgroundColor: '#dc3545', color: 'white' }}
                      >
                        Supprimer
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            <div className="modal-footer">
              <button className="btn-primary" onClick={() => setShowDetailsModal(false)}>
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
      
      {showEditModal && chargeEnEdition && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Modifier la charge</h3>
              <button className="close-btn" onClick={() => setShowEditModal(false)}>×</button>
            </div>
            <form onSubmit={sauvegarderModifications}>
              <div className="form-row">
                <div className="form-group">
                  <label>Description:</label>
                  <input 
                    type="text" 
                    name="description" 
                    value={chargeEnEdition.description} 
                    onChange={handleEditionChange} 
                    required 
                    placeholder="Ex: Électricité"
                  />
                </div>
                <div className="form-group">
                  <label>Mois concerné:</label>
                  <input 
                    type="month" 
                    name="mois" 
                    value={chargeEnEdition.mois} 
                    onChange={handleEditionChange}
                    required 
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Montant ({chargeEnEdition.devise || deviseParDefaut}):</label>
                  <input 
                    type="number" 
                    name="montant" 
                    value={chargeEnEdition.montant} 
                    onChange={handleEditionChange} 
                    step="0.01"
                    min="0"
                    required 
                    placeholder="0.00"
                  />
                </div>
                <div className="form-group">
                  <label>Devise:</label>
                  <select 
                    name="devise" 
                    value={chargeEnEdition.devise || deviseParDefaut} 
                    onChange={handleEditionChange}
                    required
                  >
                    {deviseOptions.map(option => (
                      <option key={option} value={option}>
                        {option === 'MAD' ? 'MAD - Dirham marocain' : 'CAD - Dollar canadien'}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Catégorie:</label>
                  <select 
                    name="categorie" 
                    value={chargeEnEdition.categorie} 
                    onChange={handleEditionChange}
                    required
                  >
                    <option value="">Sélectionner</option>
                    {categorieOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Récurrence:</label>
                  <select 
                    name="recurrence" 
                    value={chargeEnEdition.recurrence} 
                    onChange={handleEditionChange}
                    required
                  >
                    {recurrenceOptions.map(option => (
                      <option key={option} value={option}>
                        {formatRecurrence(option)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Échéance (optionnelle):</label>
                  <input 
                    type="date" 
                    name="dateEcheance" 
                    value={chargeEnEdition.dateEcheance} 
                    onChange={handleEditionChange} 
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group full-width">
                  <label>Notes (optionnel):</label>
                  <input 
                    type="text" 
                    name="notes" 
                    value={chargeEnEdition.notes} 
                    onChange={handleEditionChange} 
                    placeholder="Notes ou commentaires..."
                  />
                </div>
              </div>
              
              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowEditModal(false)}>
                  Annuler
                </button>
                <button type="submit" className="btn-primary">
                  Sauvegarder
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Charges;
